import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { LoginService } from 'src/app/common/services/Login.service';
import { NavigationEnd, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { constObj } from 'src/app/common/Constants/constants';
import { ConfirmDialogComponent } from 'src/app/common/shared-components/confirm-dialog/confirm-dialog.component';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { SessionService } from '../../common/services/Session.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { HttpcallService } from '../../common/services/httpcall.service';
import scrollIntoView from 'scroll-into-view-if-needed';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit, OnDestroy {

  constructor(
    private commonDataService: CommonDataService,
    public dialog: MatDialog,
    private graphQlService: GraphqlService,
    private route: Router, private httpCallService: HttpcallService,
    private loginService: LoginService,
    private session: SessionService    
  ) {
    this.isArchiveApplication();
        }

  ngOnDestroy() {
    if (this.mainCall$ !== undefined) {
      this.mainCall$.unsubscribe();
    }
    if (this.event$ !== undefined) {
      this.event$.unsubscribe();
    }
    if (this.destroy$) {
      this.destroy$.next();
      this.destroy$.complete();
    }
  }

  navData = {
    crumbData: [],
    menuData: [],
    childData: []
  }
  footerLinkData = [];
  showFooterMenu: boolean = false;
  showFooterPrintMenu: boolean = false;
  showFooterDisplayMenu: boolean = false;
  clonedNavData = {
    crumbData: [],
    menuData: [],
    childData: []
  };
  globalprint: string;
  printtoc: string;
  printselected: string;
  printannotations: string;

  displayAllAnnotations: string;
  HideAllAnnotations: string;
  displayLabel: string;
  printQueueCount: number = 0;
  userSessionRole: string;

  body;
  printOption: boolean = false;
  displayOption: boolean = false;


  /*printqueuecount = this.commonDataService.printqueueCount.subscribe();  */

  footerAPIResponse;

  temproutes = [
    "about-us",
    "copy-right",
    "contact-us",
    "help",
    "terms-and-conditions",
    ""
  ]
  event$: Subscription;
  mainCall$: Subscription;
  private destroy$: Subject<void> = new Subject<void>();
  isContentpage: boolean = false;
  ngOnInit(): void {
    this.annotationToggle = false;
    this.childData = [];
    this.printOption = false;
    this.displayOption = false;
    this.isArchiveApplication();
    this.commonDataService.resetPrintQueue.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.resetPrintQueueOnPageLoad();
    });

    let breadcrumbUrlSplits = this.route.url?.split("/");
    let breadcerumbUrl: string = "";

    if (breadcrumbUrlSplits?.length == 2) { breadcerumbUrl = this.route.url.split("/")[1]; }
    else if (breadcrumbUrlSplits?.length == 3) {
      this.isContentpage = true;
      if (this.route.url.split("/")[2] == "showallinonepage") { breadcerumbUrl = this.route.url.split("/")[1] + "-navPath"; }
      else {
        breadcerumbUrl = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2]
      }
    }
    else if (breadcrumbUrlSplits?.length == 4 || breadcrumbUrlSplits?.length == 5) {
      this.isContentpage = true;
      if (this.route.url.split("/")[3] == "showallinonepage" || this.route.url.split("/")[4] == "showallinonepage") {
        let topic = this.route.url.split("/")[1];
        let subtopic = this.route.url.split("/")[2];
        let section = this.route.url.split("/")[3] != "showallinonepage" ? this.route.url.split("/")[3] : "";
        if (section != "") {
          breadcerumbUrl = topic + "-" + subtopic + "-" + section + "-navPath";
        }
        else {
          breadcerumbUrl = topic + "-" + subtopic + "-navPath";
        }
      }
      else {
        breadcerumbUrl = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2]
      }
    } else if (breadcrumbUrlSplits?.length == 6 || breadcrumbUrlSplits?.length == 7) {
      this.isContentpage = true;
      if (this.route.url.split("/")[5] == "showallinonepage" || this.route.url.split("/")[6] == "showallinonepage") {
        let topic = this.route.url.split("/")[1];
        let subtopic = this.route.url.split("/")[2];
        let section = this.route.url.split("/")[3];
        let subsection = this.route.url.split("/")[4];
        let subsubsection = this.route.url.split("/")[5] != "showallinonepage" ? this.route.url.split("/")[5] : "";
        if (subsubsection != "") {
          breadcerumbUrl = topic + "-" + subtopic + "-" + section + "-" + subsection + "-" + subsubsection + "-navPath";
        }
        else {
          breadcerumbUrl = topic + "-" + subtopic + "-" + section + "-" + subsection + "-navPath";
        }
      }
      else {
        breadcerumbUrl = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2]
      }
    }
    if (breadcerumbUrl != "Home" && breadcerumbUrl != "ArchiveHome") {
      let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
      if (leftNavigation == undefined || leftNavigation == null) {
        this.mainCall$ = forkJoin(this.graphQlService.GetBreadcrumbSession(breadcerumbUrl), this.graphQlService.getGlobalLabels(), this.graphQlService.getGlobalFooter()).subscribe(([data, labels, glosbalFooterData]) => {
          this.commonDataService.globalLabels.next(labels);
          this.showFooterMenu = false;
          this.footerLinkData = glosbalFooterData;
          this.PrintValue = [];
          this.DisplayValue = [];
          this.getPrintDisplayMenus(labels);
          this.navData = JSON.parse(JSON.stringify(data));
          this.clonedNavData = Object.assign([], this.navData);
          this.filterBreadCrumbBasedOnRole(this.navData);
        });
      }
      else {
        this.mainCall$ = forkJoin(this.graphQlService.getGlobalLabels(), this.graphQlService.getGlobalFooter()).subscribe(([labels, glosbalFooterData]) => {
          this.commonDataService.globalLabels.next(labels);
          this.showFooterMenu = false;
          this.footerLinkData = glosbalFooterData;
          this.PrintValue = [];
          this.DisplayValue = [];
          this.getPrintDisplayMenus(labels);
          let navDataTemp;
          if (breadcerumbUrl.includes("navPath")) { navDataTemp = this.getBreadcrumbWithNavPath(breadcerumbUrl); }
          else {
            navDataTemp = this.getBreadcrumb(breadcerumbUrl);
          }
          this.clonedNavData = Object.assign([], navDataTemp);
          this.filterBreadCrumbBasedOnRole(navDataTemp);
        });
      }
    }
    else {
      this.navData.crumbData = null;
      this.printOption = false;
      this.displayOption = false;
      this.mainCall$ = forkJoin([this.graphQlService.getGlobalFooter(), this.graphQlService.getGlobalLabels()]).subscribe(([glosbalFooterData, labels]) => {
        this.showFooterMenu = false;
        this.commonDataService.globalLabels.next(labels);
        this.footerLinkData = glosbalFooterData;
        this.PrintValue = [];
        this.DisplayValue = [];
        this.getPrintDisplayMenus(labels);
      });
    }

    //this.commonDataService.navData.pipe(takeUntil(this.destroy$)).subscribe(() => {
    //  this.graphQlService.GetBreadcrumbSession(this.route.url).subscribe(data => {
    //    this.showFooterMenu = false;
    //    if (data.crumbData != null && data.menuData != null) {
    //      this.navData = JSON.parse(JSON.stringify(data));
    //    }
    //  });
    //});
    this.commonDataService.displayallannotation.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data == "default") {
        var dispval = this.DisplayValue.filter(x => x.labels == this.HideAllAnnotations)
        if (dispval.length > 0) { this.DisplayValue.filter(x => x.labels == this.HideAllAnnotations)[0].labels = this.displayAllAnnotations; }
      }
    });
    //this.commonDataService.annotationWithinContent.subscribe(data => {
    //  if (data != "" && data != null) {
    //    var dispval = this.DisplayValue.filter(x => x.labels == this.displayAllAnnotations)
    //    if (dispval.length > 0) { this.DisplayValue.filter(x => x.labels == this.displayAllAnnotations)[0].labels = this.HideAllAnnotations; }
    //  }
    //});
    this.commonDataService.printqueueCount.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != "") {
        this.printQueueCount = data == "true" ? ((this.printQueueCount < 0) ? 0 : this.printQueueCount) + 1 : ((this.printQueueCount < 0) ? 0 : this.printQueueCount) - 1;
      }
    })
    this.commonDataService.printCount.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data == "0") {
        this.printQueueCount = 0;
      }
    })
    this.event$
      = this.route.events
        ?.pipe(
          filter(event => event instanceof NavigationEnd)
        )
        ?.subscribe(() => {
          this.annotationToggle = false;
          this.navData = {
            crumbData: [],
            menuData: [],
            childData: []
          };
          this.childMenuData = [];
          this.isContentpage = false;
          breadcrumbUrlSplits = this.route.url.split("/");
          this.isArchiveApplication();
          if (breadcrumbUrlSplits.length == 2) { breadcerumbUrl = this.route.url.split("/")[1] }
          else if (breadcrumbUrlSplits.length == 3) {
            this.isContentpage = true;
            if (this.route.url.split("/")[2] == "showallinonepage") { breadcerumbUrl = this.route.url.split("/")[1] + "-navPath"; }
            else {
              breadcerumbUrl = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2]
            }
          }
          else if (breadcrumbUrlSplits.length == 4 || breadcrumbUrlSplits.length == 5) {
            this.isContentpage = true;
            if (this.route.url.split("/")[3] == "showallinonepage" || this.route.url.split("/")[4] == "showallinonepage") {
              let topic = this.route.url.split("/")[1];
              let subtopic = this.route.url.split("/")[2];
              let section = this.route.url.split("/")[3] != "showallinonepage" ? this.route.url.split("/")[3] : "";
              if (section != "") {
                breadcerumbUrl = topic + "-" + subtopic + "-" + section + "-navPath";
              }
              else {
                breadcerumbUrl = topic + "-" + subtopic + "-navPath";
              }
            }
            else {
              breadcerumbUrl = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2]
            }
          }
          else if (breadcrumbUrlSplits.length == 6 || breadcrumbUrlSplits.length == 7) {
            this.isContentpage = true;
            if (this.route.url.split("/")[5] == "showallinonepage" || this.route.url.split("/")[6] == "showallinonepage") {
              let topic = this.route.url.split("/")[1];
              let subtopic = this.route.url.split("/")[2];
              let section = this.route.url.split("/")[3];
              let subsection = this.route.url.split("/")[4];
              let subsubsection = this.route.url.split("/")[5] != "showallinonepage" ? this.route.url.split("/")[5] : "";
              if (subsubsection != "") {
                breadcerumbUrl = topic + "-" + subtopic + "-" + section + "-" + subsection + "-" + subsubsection + "-navPath";
              }
              else {
                breadcerumbUrl = topic + "-" + subtopic + "-" + section + "-" + subsection + "-navPath";
              }
            }
            else {
              breadcerumbUrl = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2]
            }
          }

          if (breadcerumbUrl != "Home" && breadcerumbUrl != "ArchiveHome") {
            let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
            if (leftNavigation == undefined || leftNavigation == null) {
              this.graphQlService.GetBreadcrumbSession(breadcerumbUrl).subscribe(data => {
                this.PrintValue = [];
                this.DisplayValue = [];
                this.navData = JSON.parse(JSON.stringify(data));
                this.clonedNavData = Object.assign([], this.navData);
                this.filterBreadCrumbBasedOnRole(this.navData);
              });
            }
            else {
              let navDataTemp;
              if (breadcerumbUrl.includes("navPath")) { navDataTemp = this.getBreadcrumbWithNavPath(breadcerumbUrl); }
              else {
                navDataTemp = this.getBreadcrumb(breadcerumbUrl);
              }
              this.clonedNavData = Object.assign([], navDataTemp);
              this.filterBreadCrumbBasedOnRole(navDataTemp);
            }
          }
          else {
            this.navData.crumbData = null;
            this.printOption = false;
            this.displayOption = false;
          }
        });
  }


  isArchive: boolean = false;
  isArchiveApplication() {
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      this.isArchive = true;
    } else { this.isArchive = false; }
  }

  DisplayValue: any[] = [];
  PrintValue: any[] = [];

  removeBreadcrumbs() {
    this.navData.crumbData = [];
    this.navData.menuData = [];
  }
  footer(obj: any,event) {
    event.preventDefault();
    if (obj.displayText == "GASB.org") {
      window.open(obj.link, "_blank");
    }
    else {
      //this.removeBreadcrumbs()
      if (obj.displayText == "Contact Us") {

        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next("Contact Support");
        this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      }
      else if (obj.displayText == "Terms and Conditions") {
        this.commonDataService.tcsource.next("");
        //this.route.navigate([obj.link]);
        this.popupRedirect(obj.link);
      }
      else {
        if (obj.link != "") {
          //this.route.navigate([obj.link]);
          this.popupRedirect(obj.link);
        }
      }
    }
  }

  onRightClick(event, obj?: any) {
    if (obj.displayText != "Contact Us") {
      if (obj.displayText == "Terms and Conditions") {
        this.commonDataService.tcsource.next("");
      }
      event.target.href = obj.link;
    }

  }

  closeFooterMenu() {
    this.showChildMenu = false;
    this.showFooterMenu = false;
  }
  footerMenuClicked(e) {  
    if (!this.route.url?.includes("showallinonepage")) {
      this.showFooterPrintMenu = false;
      this.showFooterDisplayMenu = false;
      if (e) {
        this.showFooterMenu = !this.showFooterMenu;
      }
    }

  }
footerDisplayClicked() {
    this.showFooterPrintMenu = false;
    this.showFooterMenu = false;
    this.showFooterDisplayMenu = !this.showFooterDisplayMenu;
  }
  footerPrintClicked(e) {    
    this.showFooterMenu = false;
    this.showFooterDisplayMenu = false;
    this.showFooterPrintMenu = !this.showFooterPrintMenu;
  }

  ChangeSelectedItem(selectedMenu, showChild, isdisabled) {
    if (isdisabled && !showChild ) {
      return false;      
    }
    if (showChild) {     
      this.showChildMenu = !this.showChildMenu;
      if (this.showChildMenu) { this.childMenuData = selectedMenu.childData;}
    }
    else {
      this.popupRedirect(selectedMenu.menuUrl);
      this.showChildMenu = false;
      this.showFooterMenu = false;
     
    }
  }
  /* Start -- Annonation pop-up for print queue with MS -299 */
  popupRedirect(url) {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    if (printQueueCount > 0) {
      //console.log('footer-412');
      localStorage.setItem("isConfirmPopup", "true");
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.annotationAlertPrintQueue
      });
      dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result == true) {
          if (url.includes("https://")) {
            window.open(url);
          }
          else {
            this.route.navigate([url]);
          }
        }
      });
      return;
    } else {
      if (url.includes("https://")) {
        window.open(url);
      }
      else {
        if (url != 'search') {
          this.route.navigate([url]);
        }
        else {
          this.onSearchClick();
        }
        
      }
    }
  }
  onSearchClick() {
    this.commonDataService.openSearchFromOutSide.next();
  }
  /* End -- Annonation pop-up for print queue with MS -299 */
  mainsection: string = "";

  pagepublicationId: { publid: string, pageid: string, pagetitle: string, pageurl: any, pageNavPath: string }[] = [];
  pagepubllist: { sectionarray: any[], sectionname: string, mainsectionname: string }[] = [];
  pagenavpath;
  menuurl: any;
  showallinoneclicked: boolean = false;
  ShowallInonepage(bradcrumbdata) {
    this.pagepublicationId = [];
    this.pagepubllist = [];
    this.showallinoneclicked = true;
    for (let items of bradcrumbdata) {
      this.menuurl = items?.menuUrl;
      let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
      for (let obj of leftNavigation.slice(0, 3)) {

        if (this.getpagenavpath(obj))
          break;
      }
      if (this.pagenavpath != undefined) {
        this.pagepublicationId.push({ publid: items?.menuUrl.split("/")[0], pageid: items?.menuUrl.split("/")[1], pagetitle: items?.menuItem, pageurl: items?.menuUrl, pageNavPath: this.pagenavpath });
        this.pagenavpath = undefined;
      }
    }
    this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: this.navData?.crumbData[this.navData.crumbData.length - 2], mainsectionname: this.navData.crumbData[this.navData.crumbData.length - 3] });

    localStorage.setItem("publpageId", JSON.stringify(this.pagepubllist));

    let navPath: string[] = this.pagepubllist[0]?.sectionarray[0].pageNavPath.split("-");
    navPath.pop();

    let navPathString: string = navPath.join("/");
    let url = navPathString + '/showallinonepage';

    this.navData.crumbData.pop();


    this.commonDataService.parentlevelshowallinone.next(false);
    //this.route.navigateByUrl(url);
    this.popupRedirect(url);
    this.showChildMenu = false;
    this.showFooterMenu = false;
  }
  getpagenavpath(leftnavdata) {

    for (let leftnav of leftnavdata?.itemData) {
      if (leftnav?.itemData?.length > 0) {

        this.getpagenavpath(leftnav);

      } else {
        if (leftnav.itemLink == this.menuurl) {

          this.pagenavpath = leftnav?.navPath;
          return true;
        }
      }
    }

  }

  showChildMenu: boolean = false;
  showChild() {
    this.showChildMenu = !this.showChildMenu;
  }


  ChangeSelectedPage(selectedMenu) {
    if (document.getElementById(selectedMenu.menuItem.replace(/\s\s+/g, ' ')) != null && this.route.routerState.snapshot.url?.includes(selectedMenu?.menuUrl)) {
      scrollIntoView(document.getElementById(selectedMenu.menuItem.replace(/\s\s+/g, ' ')), {
        scrollMode: 'always',
        block: 'start',
        inline: 'start',
        behavior: 'smooth',
        boundary: document.getElementsByTagName('app-main-content')[0]
      })
    } else {
      this.route.navigateByUrl(selectedMenu.menuUrl);
    }
    this.showChildMenu = false;
    this.showFooterMenu = false;
  }

  breadCrumbMenuData: any[]
  selectedPage: string = "";
  childMenuData: any[] = [];
  loggedInUserInfo;
  filterBreadCrumbBasedOnRole(navData) {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(sessiondata => { this.ApplyFilters(sessiondata, navData); })
    }
    else {
      this.ApplyFilters(this.session.userInfo, navData);
    }
  }

  ApplyFilters(sessiondata, navData) {
    this.breadCrumbMenuData = navData.menuData;
    this.selectedPage = navData.crumbData == null ? null : navData.crumbData[navData.crumbData.length - 1];


    if (this.route.url.includes("showallinonepage")) {
      this.commonDataService.parentlevelshowallinone.subscribe(data => {
        if (data) {
          navData.crumbData.pop();
        }
      })

    }
    if (this.route.url.includes("search")) {
      this.navData = null;
    }
    this.childMenuData = navData.childData;
    this.mailId = sessiondata.user.email;
    this.userSessionRole = sessiondata.user.roles;
    if (this.userSessionRole != "Basic") {
      this.GetDisplayLables();
      this.GetPrintLables();
    }
    else {
      if (!(this.route.url.includes("search?query"))) {
        this.printOption = true;
      }
      this.GetPrintLables();
      if (!(this.route.url.includes("search?query"))) {
        this.displayOption = true;
      }
      this.GetDisplayLables();
    }
    if (this.isArchive) {
      this.breadCrumbMenuData = navData?.menuData?.filter(x => x.menuItem != "Search" && x.menuItem != "Source Tracing Tool" && x.menuItem != "Glossary Term Finder")

    }
    if (sessiondata.user.roles == "Basic") {
      this.breadCrumbMenuData = navData?.menuData?.filter(x => x.menuItem != "My Bookmarks" && x.menuItem != "My History" && x.menuItem != "My Annotations" && x.menuItem != "Redis Cache Management" );
      if (this.isArchive) {
        this.breadCrumbMenuData = navData?.menuData?.filter(x => x.menuItem != "My Bookmarks" && x.menuItem != "My History" && x.menuItem != "My Annotations" && x.menuItem != "Redis Cache Management" && x.menuItem != "Search" && x.menuItem != "Source Tracing Tool" && x.menuItem != "Glossary Term Finder");

      }
    }
  }

  GetPrintLables() {
    let routerpart = this.route.url.split("/");
    if (this.route.url.includes("showallinonepage")) {
      this.printOption = true;
      this.PrintValue[0].DisplayOrNot =  false;
      this.PrintValue[1].DisplayOrNot = true;
      this.PrintValue[2].DisplayOrNot = true;
    }
    else if (routerpart.length == 2) {
      if (this.route.url == "/Home" || this.route.url == "/ArchiveHome" || this.route.url == "/myBookmarks" || this.route.url == "/GlossaryTermFinder" || this.route.url == "/sourcetracingtool" || this.route.url == "/myaccountdetails" ||
        this.route.url == "/MyHistory" || this.route.url == "/myAnnotations" || this.route.url == "/RedisCacheManagement" || this.route.url.includes("/search?query") || this.route.url == "/effectivedates") {
        this.printOption = false;
      }
      else if (this.route.url == "/about-us" || this.route.url == "/copy-right" || this.route.url.includes("terms-and-conditions") || this.route.url.includes("/help") || this.route.url.includes("/docspublicComment") || this.route.url.includes("/implementationguides") || this.route.url.includes("/finalpronouncements") || this.route.url.includes("/TocLinks")) {
        this.printOption = true;
        this.PrintValue[0].DisplayOrNot = false;
        this.PrintValue[1].DisplayOrNot = true;
        this.PrintValue[2].DisplayOrNot = false;
      }
      else if (this.route.url == "/archiveContent") {
        this.printOption = true;
        this.PrintValue[0].DisplayOrNot = false;
        this.PrintValue[1].DisplayOrNot = true;
        this.PrintValue[2].DisplayOrNot = true;
      }
    }
    else if (routerpart.length >= 3) {
      if (this.navData.crumbData != null) {
        if (this.navData.crumbData[0] == "Other Reference") {
          this.printOption = true;
          this.PrintValue[0].DisplayOrNot = false;
          this.PrintValue[1].DisplayOrNot = true;
          this.PrintValue[2].DisplayOrNot = false;
        } else {
          this.printOption = true;
          this.PrintValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
          this.PrintValue[1].DisplayOrNot = true;
          this.PrintValue[2].DisplayOrNot = true;
        }
      }
      else {
        if (!this.route.url.includes("showallinonepage") && !this.route.url.includes("tableOfContent")) {
          let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
          if (leftNavigation == undefined || leftNavigation == null) {
            this.graphQlService.GetBreadcrumbSession(this.route.url).subscribe(data => {
              this.navData = JSON.parse(JSON.stringify(data));
              if (this.navData.crumbData != null) {
                if (this.navData.crumbData[0] == "Other Reference") {
                  this.printOption = true;
                  this.PrintValue[0].DisplayOrNot = false;
                  this.PrintValue[1].DisplayOrNot = true;
                  this.PrintValue[2].DisplayOrNot = false;
                } else {
                  this.printOption = true;
                  this.PrintValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
                  this.PrintValue[1].DisplayOrNot = true;
                  this.PrintValue[2].DisplayOrNot = true;
                }
              }
              else {
                this.printOption = false;
              }
            })
          } else {
            this.navData = this.getBreadcrumb(this.route.url);
            if (this.navData.crumbData != null) {
              if (this.navData.crumbData[0] == "Other Reference") {
                this.printOption = true;
                this.PrintValue[0].DisplayOrNot = false;
                this.PrintValue[1].DisplayOrNot = true;
                this.PrintValue[2].DisplayOrNot = false;
              } else {
                this.printOption = true;
                this.PrintValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
                this.PrintValue[1].DisplayOrNot = true;
                this.PrintValue[2].DisplayOrNot = true;
              }
            }
            else {
              this.printOption = false;
            }
          }
        }
        else {
          this.printOption = true;
          if (!this.route.url.includes("tableOfContent")) {
            this.PrintValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
            this.PrintValue[1].DisplayOrNot = true;
            this.PrintValue[2].DisplayOrNot = true;
          } else {
            this.PrintValue[0].DisplayOrNot = false;
            this.PrintValue[1].DisplayOrNot = true;
            this.PrintValue[2].DisplayOrNot = false;
          }
        }
      }
    }
  }

  GetDisplayLables() {
    let routerpart = this.route.url.split("/");
    if (this.route.url.includes("showallinonepage")) {
      this.displayOption = false;
    }
    else if (routerpart.length == 2) {
      if (this.route.url == "/Home" || this.route.url == "/ArchiveHome" || this.route.url == "/myBookmarks" || this.route.url == "/GlossaryTermFinder" || this.route.url == "/sourcetracingtool" ||
        this.route.url == "/MyHistory" || this.route.url == "/myAnnotations" || this.route.url == "/about-us" || this.route.url == "/copy-right"
        || this.route.url == "/terms-and-conditions" || this.route.url.includes("/help") || this.route.url.includes("/TocLinks") || this.route.url.includes("/RedisCacheManagement") ||
        this.route.url.includes("/search?query") || this.route.url.includes("/docspublicComment") || this.route.url.includes("/implementationguides") || this.route.url.includes("/finalpronouncements")) {
        this.displayOption = false;
      }
      else if (this.route.url == "/archiveContent") {
        this.displayOption = true;
        this.DisplayValue[0].DisplayOrNot = false;
      }
    }
    else if (routerpart.length >= 3) {
      if (this.navData.crumbData != null) {
        if (this.navData.crumbData[0] == "Other Reference") {
          this.displayOption = false;
        } else {
          this.displayOption = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
          this.DisplayValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
        }
      }
      else {
        if (!this.route.url.includes("showallinonepage")) {
          let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
          if (leftNavigation == undefined || leftNavigation == null) {
            this.graphQlService.GetBreadcrumbSession(this.route.url).subscribe(data => {
              this.navData = JSON.parse(JSON.stringify(data));
              if (this.navData.crumbData != null) {
                if (this.navData.crumbData[0] == "Other Reference") {
                  this.displayOption = false;
                } else {
                  this.displayOption = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
                  this.DisplayValue[0].DisplayOrNot = (this.userSessionRole != "Basic") ? true : false;
                }
              }
              else {
                this.displayOption = false;
              }
            })
          }
          else {
            this.navData = this.getBreadcrumb(this.route.url);
            if (this.navData.crumbData != null) {
              if (this.navData.crumbData[0] == "Other Reference") {
                this.displayOption = false;
              } else {
                this.displayOption = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
                this.DisplayValue[0].DisplayOrNot = (this.userSessionRole != "Basic") ? true : false;
              }
            }
            else {
              this.displayOption = false;
            }
          }
        }
        else {
          this.displayOption = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
          this.DisplayValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
        }
      }
    }
  }
  labelItems: any;
  getPrintDisplayMenus(data) {
    if (data != null) {
      var labels = data.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.labelItems = labels;
      this.globalprint = labels.filter(x => x.key == "global_print").map(y => y.value);
      this.printtoc = labels.filter(x => x.key == "print_toc").map(y => y.value);
      this.printselected = labels.filter(x => x.key == "print_selected").map(y => y.value);
      this.printannotations = labels.filter(x => x.key == "print_annotations").map(y => y.value);

      this.displayLabel = labels.filter(x => x.key == "display_displayLabel").map(y => y.value);
      this.displayAllAnnotations = labels.filter(x => x.key == "display_displayAllAnnotations").map(y => y.value);
      this.HideAllAnnotations = labels.filter(x => x.key == "display_hideAllAnnotations").map(y => y.value);
      this.PrintValue.push({ 'labels': "Include Annotations", "toggle": true, 'DisplayOrNot': true });
      this.PrintValue.push({ 'labels': this.globalprint, 'DisplayOrNot': true });
      //this.PrintValue.push({ 'labels': this.printtoc, 'DisplayOrNot': true });
      this.PrintValue.push({ 'labels': this.printselected, 'deletedIcon': true, 'printselectedCount': true, 'DisplayOrNot': true });

      this.DisplayValue.push({
        'labels': this.displayAllAnnotations, 'imgPath': '../../../assets/icons/MyAnnotation-black.svg',
        'id': 'displayAllAnnotations', 'alt': 'Annotations', 'DisplayOrNot': true
      });
      this.GetPrintLables();
      this.GetDisplayLables();

    }
  }

  printPreviewOverlay() {

    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("print preview");
    this.commonDataService.closeModalOption.next(false);
  }

  globalPrint() {
    this.commonDataService.printpreviewFileName.next("");
    this.printPreviewOverlay();
    let str = this.isArchive ? `<div class="printBox ArchiveContent">` : `<div class="printBox">`;
    var hide = document.getElementsByClassName("print-content-hide")
    Array.prototype.forEach.call(hide, function (obj) {
      obj.style.display = "none"
    });

    var printOnly = document.getElementsByClassName("print");
    Array.prototype.forEach.call(printOnly, function (obj) {
      obj.style.display = "block"
    });
    var contents = document.getElementsByClassName("print-content");
    Array.prototype.forEach.call(contents, function (element) {
      str += `<div class="printScreenBlock"> ${element.innerHTML} </div>`;
    });
    var footnoteContent = document.getElementsByClassName("print-all-footnote-content");
    if (footnoteContent.length > 0) {
      str += `<div> <hr /> </div>`;
    }
    Array.prototype.forEach.call(footnoteContent, function (element) {
      str += `<div> ${element.innerHTML} </div>`;
    });
    str += '</div>'

    Array.prototype.forEach.call(hide, function (obj) {
      obj.style.display = "flex";
    });

    setTimeout(() => {
      document.getElementById("printPreviewArticle").innerHTML = "";
      document.getElementById("printPreviewArticle").innerHTML += str;
      //const pageHeading = document.getElementById("pageHeading");
      //if (!this.route.url.includes("finalpronouncements")) {
      //  if (pageHeading?.innerHTML) {
      //    document.getElementById("pageHeadingprint").innerHTML = pageHeading.innerHTML;
      //    document.getElementById("pageHeadingprint").className = pageHeading.classList.value;
      //  }
      //}
    }, 1000)
  }

  SortObjectByProperty(property) {
    return function (a, b) {
      let A;
      let B;
      let result;
      if (/\d/.test(a[property]) && /\d/.test(b[property])) {
        A = parseInt(a[property]);
        B = parseInt(b[property]);
        result = A < B ? -1 : (A > B ? 1 : 0);
      }
      else {
        A = a[property];
        B = b[property];
        result = A.localeCompare(B);
      }
      return result;
    }
  }

  compare(a, b) {
    let aPNum: number = parseInt(a.paraIteration);
    let bPNum: number = parseInt(b.paraIteration);
    if (aPNum < bPNum) {
      return -1;
    }
    else if (aPNum > bPNum) {
      return 1;
    }
    else {
      return 0;
    }
  }
  mailId: string = "";
  mainsectionname: string = "";
  sectionname: string = "";
  pageSelectAnnotationsForPrint: any = {};
  /* eslint-disable */
  printpreview(printobj) {
    this.commonDataService.currentParagraph.next("");
    if (printobj != null && printobj.labels[0] === this.printselected[0]) {
      if (this.printQueueCount > 0) {
        this.printPreviewOverlay();
      }
      let footnoteSection: any[] = [];
      if (this.userSessionRole != "Basic") {
        let inputBody = { "NavigationPath": "GARS", "Application": "GARS", "paragraphId": "" };
        this.httpCallService.getPageAnnotation(inputBody).subscribe(data1 => {
          this.pageSelectAnnotationsForPrint = data1;
          this.commonDataService.printpreviewFileName.next("");
          let data = JSON.parse(localStorage.getItem("SetPrintQueueSession"));
          if (data != null && data.ParagraphIdsList != null) {
            let str = this.isArchive ? `<div class="printBox ArchiveContent">` : `<div class="printBox">`;
            let paraList = data.ParagraphIdsList;
            let isParaNumUndefined = paraList.some(a => a.paraIteration == undefined || a.paraIteration == null);
            let headingProperty = "";

            if (!isParaNumUndefined) {
              paraList.sort(this.compare);
            }
            let isIterationUndefined = paraList.some(a => a.pageNumber == undefined || a.pageNumber == null);
            if (!isIterationUndefined) {
              paraList.sort(this.SortObjectByProperty('pageNumber'));
            }
            let isFirstPara: boolean = true;
            let j: number = 100;
            this.mainsectionname = document.getElementById("breadcrumbShowAll").innerHTML;
            str += `<div>${this.mainsectionname.split('____')[0]}</div>`;
            if (this.route.url.includes("showallinonepage")) {
              this.sectionname = document.getElementById("section-name") == null ? "" : document.getElementById("section-name").innerHTML;
              str += `<div *ngIf="isShowAllInOnePage" style="margin-bottom: 2rem;">`;
              //<div id="main-section-name" class="generalHeader ml-3 font-40">
              //  ${this.mainsectionname}
              //</div>`;
              if (this.sectionname != "") {
                str += `<div id="section-name" *ngIf="sectionname != ''" class="generalHeader font-40" >
              ${this.sectionname.split('____')[0]}
            </div>`;
              }
              str += `</div>`;
            }
            for (let i = 0; i < paraList.length; i++) {
              if (parseInt(paraList[i].pageNumber == undefined ? "0" : paraList[i].pageNumber) != j) { isFirstPara = true; j = parseInt(paraList[i].pageNumber); }
              let printItems = document.getElementsByClassName(paraList[i].value);
              let paraNumber = paraList[i].paraNum;
              if (isFirstPara) {
                //str += `<div id="printHeader" class="ml-invert-1" style="margin-bottom: 1rem;">
                //          <h1 class="nested0">${paraList[i].key.changingThisBreaksApplicationSecurity.split('____')[0]}</span>
                //        </div>`;
                isFirstPara = false;
              }
              if (printItems.length > 1) {
                let content = document.getElementsByClassName(paraList[i].value)[1]?.innerHTML;
                let footnoteClass = document.getElementsByClassName(paraList[i].value)[1]?.getElementsByClassName("footnote");
                for (let a = 0; a < footnoteClass?.length; a++) { footnoteSection.push(footnoteClass[a].id.replace("_Content", "")); }
                let heading = document.getElementsByClassName(paraList[i].value)[0]?.innerHTML;
                str += `<div class="topicBody">
                     <div >
                        <div class="font-18 itcBookFont boldFont mb-0-8rem"><span class="ph">${heading}</span></div>
                     </div>`
                if (paraNumber == 'Glossary' && (!this.route.url.includes("showallinonepage"))) {
                  str += `<div class="component ml-80px><div class="topicBody"><h2 class="mb-1-imp width-headings"><b>`;
                  if (paraList[i].paraHeading[0] != "" && paraList[i].paraHeading[0] != undefined) {
                    str += `<span class="nested1 mb-0-8rem" > ${paraList[i].paraHeading[0].changingThisBreaksApplicationSecurity.split('____')[0]} </span>`;
                  }
                  if (paraList[i].paraHeading[1] != "" && paraList[i].paraHeading[1] != undefined) {
                    str += `<span class="nested2 mb-0-8rem" > ${paraList[i].paraHeading[1].changingThisBreaksApplicationSecurity.split('____')[0]} </span>`;
                  }
                  if (paraList[i].paraHeading[2] != "" && paraList[i].paraHeading[2] != undefined) {
                    str += `<span class="nested3 mb-0-8rem" > ${paraList[i].paraHeading[2].changingThisBreaksApplicationSecurity.split('____')[0]} </span>`;
                  }
                  str += `</b></h2></div></div>`;
                }
                str += `<div class='printShow' role="navigation">
                        <div class="flex-display">`;
                let isParaNum: boolean = paraNumber != '' && paraNumber != null && paraNumber != 'highlight.' && paraNumber != 'Glossary';
                if (isParaNum) {
                  str += `<div class="paragraphId width-10">${paraNumber.split('____')[0]}</div>`;
                  str += `<div role="region" class="print-content" style="width:90%">`;
                }
                else {
                  str += `<div role="region" class="print-content">`;
                }
                str += `                 <div class="p">${content}</div>
                           </div>
                        </div>
                     </div>`;
                if (this.annotationToggle) {
                  if (this.pageSelectAnnotationsForPrint[paraList[i].value] != undefined) {
                    let hrWidth = isParaNum ? "annotationWithinContent" : "annotationContentBoolWithoutNum";
                    str += `<div class="` + hrWidth + `"><hr />`;
                    for (let b = 0; b < this.pageSelectAnnotationsForPrint[paraList[i].value].length; b++) {
                      str += `<div class="annotation-content-title">` + this.pageSelectAnnotationsForPrint[paraList[i].value][b].annotationTitle + `</div><div class="my-0-25 flex-display">`;
                      str += `<div class="flex-display mb-0-25"><span class="sub-title-label"><strong>Added</strong>:&nbsp;</span>&nbsp;<span class="sub-content">` + this.pageSelectAnnotationsForPrint[paraList[i].value][b].createdOn.split(" ")[0] + `</div></div>`;
                      str += `<div class="sub-content-description my-1">` + this.pageSelectAnnotationsForPrint[paraList[i].value][b].annotationDescription + `</div><hr />`;
                    }
                    str += `</div>`
                  }
                }

                str += `</div>`;
              }
              else {
                //if (isFirstPara) {
                //  const pageHeading = document.getElementById("pageHeading");
                //  console.log(document.getElementById("pageHeadingprint").innerHTML);
                //  document.getElementById("pageHeadingprint").innerHTML = pageHeading?.innerHTML;
                //  document.getElementById("pageHeadingprint").className = pageHeading?.classList?.value;
                //  //str += `<div id="printHeader" style="margin-bottom: 1rem;">
                //  //      <span class="generalHeader">${paraList[i].key.changingThisBreaksApplicationSecurity}</span>
                //  //    </div>`;
                //  isFirstPara = false;
                //}
                let content = document.getElementsByClassName(paraList[i].value)[0]?.innerHTML;
                let footnoteClass = document.getElementsByClassName(paraList[i].value)[0]?.getElementsByClassName("footnote");
                for (let c = 0; c < footnoteClass?.length; c++) { footnoteSection.push(footnoteClass[c].id.replace("_Content", "")); }

                str += `<div class="topicBody">`
                if (paraNumber == 'Glossary') {
                  str += `<div class="component ml-80px><div class="topicBody"><h2 class="mb-1-imp width-headings"><b>`;
                  if (paraList[i].paraHeading[0] != "" && paraList[i].paraHeading[0] != undefined) {
                    str += `<span class="nested1 mb-0-8rem" > ${paraList[i].paraHeading[0].changingThisBreaksApplicationSecurity.split('____')[0]} </span>`;
                  }
                  if (paraList[i].paraHeading[1] != "" && paraList[i].paraHeading[1] != undefined) {
                    str += `<span class="nested2 mb-0-8rem" > ${paraList[i].paraHeading[1].changingThisBreaksApplicationSecurity.split('____')[0]} </span>`;
                  }
                  if (paraList[i].paraHeading[2] != "" && paraList[i].paraHeading[2] != undefined) {
                    str += `<span class="nested3 mb-0-8rem" > ${paraList[i].paraHeading[2].changingThisBreaksApplicationSecurity.split('____')[0]} </span>`;
                  }
                  str += `</b></h2></div></div>`;
                }
                str += `<div class='printShow' role="navigation">
                        <div class="flex-display">`;
                let isParaNum: boolean = paraNumber != '' && paraNumber != null && paraNumber != 'highlight.' && paraNumber != 'Glossary';
                if (isParaNum) {
                  str += `<div class="paragraphId width-10">${paraNumber.split('____')[0]}</div>`;
                  str += `<div role="region" class="print-content" style="width:90%">`;
                }
                else {
                  str += `<div role="region" class="print-content">`;
                }
                str += `         <div class="p">${content}</div>
                           </div>
                        </div>
                     </div>`;
                if (this.annotationToggle) {
                  if (this.pageSelectAnnotationsForPrint[paraList[i].value] != undefined) {
                    let hrWidth = isParaNum ? "annotationWithinContent" : "annotationContentBoolWithoutNum";
                    str += `<div class="` + hrWidth + `"><hr />`;
                    for (let d = 0; d < this.pageSelectAnnotationsForPrint[paraList[i].value].length; d++) {
                      str += `<div class="annotation-content-title">` + this.pageSelectAnnotationsForPrint[paraList[i].value][d].annotationTitle + `</div><div class="my-0-25 flex-display">`;
                      str += `<div class="flex-display mb-0-25"><span class="sub-title-label"><strong>Added</strong>:&nbsp;</span>&nbsp;<span class="sub-content">` + this.pageSelectAnnotationsForPrint[paraList[i].value][d].createdOn.split(" ")[0] + `</div></div>`;
                      str += `<div class="sub-content-description my-1">` + this.pageSelectAnnotationsForPrint[paraList[i].value][d].annotationDescription + `</div><hr />`;
                    }
                    str += `</div>`
                  }
                }
              }
              str += '<br />';
            }
            if (footnoteSection.length > 0) { str += '<hr class="mb-0-8rem">'; }
            for (let i = 0; i < footnoteSection.length; i++) {
              str += `<div class="mb-0-8rem">` + document.getElementById(footnoteSection[i]).parentElement.outerHTML + `</div>`
            }

            str += '</div>';
            setTimeout(() => {
              document.getElementById("printPreviewArticle").innerHTML = "";
              document.getElementById("printPreviewArticle").innerHTML += str;
              //const pageHeading = document.getElementById("pageHeading");
              //document.getElementById("pageHeadingprint").innerHTML += pageHeading?.innerHTML;
            }, 1000);
          }
        });
      }
      else {
        this.commonDataService.printpreviewFileName.next("");
        let data = JSON.parse(localStorage.getItem("SetPrintQueueSession"));
        if (data != null && data.ParagraphIdsList != null) {
          let str = this.isArchive ? `<div class="printBox ArchiveContent">` : `<div class="printBox">`;
          let paraList = data.ParagraphIdsList;
          let isParaNumUndefined = paraList.some(a => a.paraIteration == undefined || a.paraIteration == null);
          let headingProperty = "";

          if (!isParaNumUndefined) {
            paraList.sort(this.compare);
          }
          let isIterationUndefined = paraList.some(a => a.pageNumber == undefined || a.pageNumber == null);
          if (!isIterationUndefined) {
            paraList.sort(this.SortObjectByProperty('pageNumber'));
          }
          let isFirstPara: boolean = true;
          let j: number = 100;
          this.mainsectionname = document.getElementById("breadcrumbShowAll").innerHTML;
          str += `<div>${this.mainsectionname.split('____')[0]}</div>`;
          if (this.route.url.includes("showallinonepage")) {
            this.sectionname = document.getElementById("section-name") == null ? "" : document.getElementById("section-name").innerHTML;
            str += `<div *ngIf="isShowAllInOnePage" style="margin-bottom: 2rem;">`;
            //<div id="main-section-name" class="generalHeader ml-3 font-40">
            //  ${this.mainsectionname}
            //</div>`;
            if (this.sectionname != "") {
              str += `<div id="section-name" *ngIf="sectionname != ''" class="generalHeader font-40" >
              ${this.sectionname.split('____')[0]}
            </div>`;
            }
            str += `</div>`;
          }
          for (let i = 0; i < paraList.length; i++) {
            if (parseInt(paraList[i].pageNumber == undefined ? "0" : paraList[i].pageNumber) != j) { isFirstPara = true; j = parseInt(paraList[i].pageNumber); }
            let printItems = document.getElementsByClassName(paraList[i].value);
            let paraNumber = paraList[i].paraNum;
            if (isFirstPara) {
              //str += `<div id="printHeader" class="ml-invert-1" style="margin-bottom: 1rem;">
              //          <h1 class="nested0">${paraList[i].key.changingThisBreaksApplicationSecurity.split('____')[0]}</span>
              //        </div>`;
              isFirstPara = false;
            }
            if (printItems.length > 1) {
              let content = document.getElementsByClassName(paraList[i].value)[1]?.innerHTML;
              let footnoteClass = document.getElementsByClassName(paraList[i].value)[1]?.getElementsByClassName("footnote");
              for (let e = 0; e < footnoteClass?.length; e++) { footnoteSection.push(footnoteClass[e].id.replace("_Content", "")); }
              let heading = document.getElementsByClassName(paraList[i].value)[0]?.innerHTML;
              str += `<div class="topicBody">
                     <div >
                        <div class="font-18 itcBookFont boldFont mb-0-8rem"><span class="ph">${heading}</span></div>
                     </div>`
              if (paraNumber == 'Glossary' && (!this.route.url.includes("showallinonepage"))) {
                str += `<div class="component ml-80px><div class="topicBody"><h2 class="mb-1-imp width-headings"><b>`;
                if (paraList[i].paraHeading[0] != "" && paraList[i].paraHeading[0] != undefined) {
                  str += `<span class="nested1 mb-0-8rem" > ${paraList[i].paraHeading[0].split('____')[0]} </span>`;
                }
                if (paraList[i].paraHeading[1] != "" && paraList[i].paraHeading[1] != undefined) {
                  str += `<span class="nested2 mb-0-8rem" > ${paraList[i].paraHeading[1].split('____')[0]} </span>`;
                }
                if (paraList[i].paraHeading[2] != "" && paraList[i].paraHeading[2] != undefined) {
                  str += `<span class="nested3 mb-0-8rem" > ${paraList[i].paraHeading[2].split('____')[0]} </span>`;
                }
                str += `</b></h2></div></div>`;
              }
              str += `<div class='printShow' role="navigation">
                        <div class="flex-display">`;
              let isParaNum: boolean = paraNumber != '' && paraNumber != null && paraNumber != 'highlight.' && paraNumber != 'Glossary';
              if (isParaNum) {
                str += `<div class="paragraphId width-10">${paraNumber.split('____')[0]}</div>`;
                str += `<div role="region" class="print-content" style="width:90%">`;
              }
              else {
                str += `<div role="region" class="print-content">`;
              }
              str += `                 <div class="p">${content}</div>
                           </div>
                        </div>
                     </div>`;

              str += `</div>`;
            }
            else {
              //if (isFirstPara) {
              //  const pageHeading = document.getElementById("pageHeading");
              //  console.log(document.getElementById("pageHeadingprint").innerHTML);
              //  document.getElementById("pageHeadingprint").innerHTML = pageHeading?.innerHTML;
              //  document.getElementById("pageHeadingprint").className = pageHeading?.classList?.value;
              //  //str += `<div id="printHeader" style="margin-bottom: 1rem;">
              //  //      <span class="generalHeader">${paraList[i].key.changingThisBreaksApplicationSecurity}</span>
              //  //    </div>`;
              //  isFirstPara = false;
              //}
              let content = document.getElementsByClassName(paraList[i].value)[0]?.innerHTML;
              let footnoteClass = document.getElementsByClassName(paraList[i].value)[0]?.getElementsByClassName("footnote");
              for (let f = 0; f < footnoteClass?.length; f++) { footnoteSection.push(footnoteClass[f].id.replace("_Content", "")); }

              str += `<div class="topicBody">`
              if (paraNumber == 'Glossary') {
                str += `<div class="component ml-80px><div class="topicBody"><h2 class="mb-1-imp width-headings"><b>`;
                if (paraList[i].paraHeading[0] != "" && paraList[i].paraHeading[0] != undefined) {
                  str += `<span class="nested1 mb-0-8rem" > ${paraList[i].paraHeading[0].split('____')[0]} </span>`;
                }
                if (paraList[i].paraHeading[1] != "" && paraList[i].paraHeading[1] != undefined) {
                  str += `<span class="nested2 mb-0-8rem" > ${paraList[i].paraHeading[1].split('____')[0]} </span>`;
                }
                if (paraList[i].paraHeading[2] != "" && paraList[i].paraHeading[2] != undefined) {
                  str += `<span class="nested3 mb-0-8rem" > ${paraList[i].paraHeading[2].split('____')[0]} </span>`;
                }
                str += `</b></h2></div></div>`;
              }
              str += `<div class='printShow' role="navigation">
                        <div class="flex-display">`;
              let isParaNum: boolean = paraNumber != '' && paraNumber != null && paraNumber != 'highlight.' && paraNumber != 'Glossary';
              if (isParaNum) {
                str += `<div class="paragraphId width-10">${paraNumber.split('____')[0]}</div>`;
                str += `<div role="region" class="print-content" style="width:90%">`;
              }
              else {
                str += `<div role="region" class="print-content">`;
              }
              str += `         <div class="p">${content}</div>
                           </div>
                        </div>
                     </div>`;
            }
            str += '<br />';
          }
          if (footnoteSection.length > 0) { str += '<hr class="mb-0-8rem">'; }
          for (let i = 0; i < footnoteSection.length; i++) {
            str += `<div class="mb-0-8rem">` + document.getElementById(footnoteSection[i]).parentElement.outerHTML + `</div>`
          }

          str += '</div>';
          setTimeout(() => {
            document.getElementById("printPreviewArticle").innerHTML = "";
            document.getElementById("printPreviewArticle").innerHTML += str;
            //const pageHeading = document.getElementById("pageHeading");
            //document.getElementById("pageHeadingprint").innerHTML += pageHeading?.innerHTML;
          }, 1000);
        }
      }
    }
    if (printobj != null && printobj.labels[0] === this.globalprint[0] && (!this.annotationToggle)) {
      this.globalPrint();
    }
    else if (printobj != null && printobj.labels[0] === this.globalprint[0] && (this.annotationToggle)) {
      this.commonDataService.showLoader.next(true);
      this.printPreviewOverlay();
      this.commonDataService.displayallannotation.next("displayallannotationswithprint");
      this.commonDataService.printpreviewFileName.next("PP_withallannotations");
    }
  }
  /* eslint-enable */
  displayAll(obj: any) {
    this.commonDataService.showLoader.next(true);
    this.commonDataService.printwithannotations.next("");
    if (obj.labels == this.displayAllAnnotations) {
      this.commonDataService.displayallannotation.next("displayallannotations");
      this.DisplayValue.filter(x => x.labels == this.displayAllAnnotations)[0].labels = this.HideAllAnnotations
    }

    else if (obj.labels == this.HideAllAnnotations) {
      this.commonDataService.displayallannotation.next("hideallannotations");
      this.DisplayValue.filter(x => x.labels == this.HideAllAnnotations)[0].labels = this.displayAllAnnotations
      this.commonDataService.showLoader.next(false);
    }
  }

  resetPrintQueueOnPageLoad() {
    localStorage.setItem("SetPrintQueueSession", JSON.stringify({}));    
    this.printQueueCount = 0;
    var hide = document.getElementsByClassName("Print-Queue-icon")
    Array.prototype.forEach.call(hide, function (obj) {
      obj.style.display = "none"
    });
    this.commonDataService.printCount.next("toggleOff");
    this.commonDataService.printToggleOff.next("printToggleOff");
  }

  deletePrintQueue(printobj) {
    if (printobj.deletedIcon && this.printQueueCount > 0) {
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.deleteAllPrintQueue
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.commonDataService.isConfirmationPopUpOpen.next(false);
          this.commonDataService.showLoader.next(true);
          localStorage.removeItem("SetPrintQueueSession");
          this.printQueueCount = 0;
          var hide = document.getElementsByClassName("Print-Queue-icon")
          Array.prototype.forEach.call(hide, function (obj) {
            obj.style.display = "none"
          });
          this.commonDataService.showLoader.next(false);
          this.commonDataService.printCount.next("toggleOff");
          this.commonDataService.printToggleOff.next("printToggleOff");

        }
      });
    }
  }

  isEffectiveDate: boolean = false;
  menuData;
  getBreadcrumb(breadcerumbUrl) {
    this.isEffectiveDate = false; 
    if (breadcerumbUrl.startsWith("help")) { breadcerumbUrl = "help"; }
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 0; i < leftNavigation.length; i++) {
      this.childData = [];
      let crumbData = [];
      this.menuData = [];
      if (leftNavigation[i].itemLink != null && leftNavigation[i].itemLink != "" && (leftNavigation[i].itemData?.length == 0 || leftNavigation[i].rollUp == "True")) {
        if (leftNavigation[i].itemLink?.includes(breadcerumbUrl)) {
          crumbData.push(leftNavigation[i].item);
          this.getMenuData(leftNavigation);
          this.getChildData(leftNavigation[i])
          this.navData.crumbData = crumbData;
          this.navData.menuData = this.menuData;
          this.navData.childData = this.childData;
          return this.navData;
        }
      } else {
        if (leftNavigation[i].itemData != null && leftNavigation[i].itemData?.length > 0) {
          for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
            if (leftNavigation[i].itemData[j].itemLink != null && leftNavigation[i].itemData[j].itemLink != "" && (leftNavigation[i].itemData[j].itemData?.length == 0 || leftNavigation[i].itemData[j].rollUp == "True")) {
              if (leftNavigation[i].itemData[j].itemLink?.includes(breadcerumbUrl)) {
                if (leftNavigation[i].itemData[j].item == "Effective Dates and Certain Transition Provisions") { this.isEffectiveDate = true; }
                else { this.isEffectiveDate = false; }
                crumbData.push(leftNavigation[i].item);
                crumbData.push(leftNavigation[i].itemData[j].item);
                this.getMenuData(leftNavigation[i].itemData);
                this.getChildData(leftNavigation[i].itemData[j]);
                this.navData.crumbData = crumbData;
                this.navData.menuData = this.menuData;
                this.navData.childData = this.childData;
                return this.navData;
              }
            } else {
              if (leftNavigation[i].itemData[j].itemData != null && leftNavigation[i].itemData[j].itemData?.length > 0) {
                for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
                  if (leftNavigation[i].itemData[j].itemData[k].itemLink != null && leftNavigation[i].itemData[j].itemData[k].itemLink != "" && (leftNavigation[i].itemData[j].itemData[k].itemData?.length == 0 || leftNavigation[i].itemData[j].itemData[k].rollUp == "True")) {
                    if (leftNavigation[i].itemData[j].itemData[k].itemLink?.includes(breadcerumbUrl)) {
                      crumbData.push(leftNavigation[i].item);
                      crumbData.push(leftNavigation[i].itemData[j].item);
                      crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                      this.getMenuData(leftNavigation[i].itemData[j].itemData);
                      this.getChildData(leftNavigation[i].itemData[j].itemData[k]);
                      this.navData.crumbData = crumbData;
                      this.navData.menuData = this.menuData;
                      this.navData.childData = this.childData;
                      return this.navData;
                    }
                  } else {
                    if (leftNavigation[i].itemData[j].itemData[k].itemData != null && leftNavigation[i].itemData[j].itemData[k].itemData?.length > 0) {
                      for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink != null && leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink != "" && (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData?.length == 0 || leftNavigation[i].itemData[j].itemData[k].itemData[l].rollUp == "True")) {
                          if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink?.includes(breadcerumbUrl)) {
                            crumbData.push(leftNavigation[i].item);
                            crumbData.push(leftNavigation[i].itemData[j].item);
                            crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                            crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                            this.getMenuData(leftNavigation[i].itemData[j].itemData[k].itemData);
                            this.getChildData(leftNavigation[i].itemData[j].itemData[k].itemData[l]);
                            this.navData.crumbData = crumbData;
                            this.navData.menuData = this.menuData;
                            this.navData.childData = this.childData;
                            return this.navData;
                          }
                        }
                        else {
                          if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null && leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData?.length > 0) {
                            for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                              if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].itemLink?.includes(breadcerumbUrl)) {
                                crumbData.push(leftNavigation[i].item);
                                crumbData.push(leftNavigation[i].itemData[j].item);
                                crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                                crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                                crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item);
                                this.getMenuData(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData);
                                this.getChildData(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m]);
                                this.navData.crumbData = crumbData;
                                this.navData.menuData = this.menuData;
                                this.navData.childData = this.childData;
                                return this.navData;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    this.navData.crumbData = null;
    this.navData.menuData = null;
    return this.navData;
  }

  getBreadcrumbWithNavPath(breadcerumbUrl) {
    breadcerumbUrl = breadcerumbUrl.replace("-navPath", "");
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 0; i < leftNavigation.length; i++) {
      let crumbData = [];
      this.menuData = null;
      this.navData.menuData = this.menuData;
      if (leftNavigation[i]?.navPath == breadcerumbUrl) {
        crumbData.push(leftNavigation[i].item);
        this.navData.crumbData = crumbData;
        return this.navData;
      } else {
        if (leftNavigation[i].itemData != null && leftNavigation[i].itemData.length > 0) {
          for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
            if (leftNavigation[i].itemData[j]?.navPath == breadcerumbUrl) {
              crumbData.push(leftNavigation[i].item);
              crumbData.push(leftNavigation[i].itemData[j].item);
              this.navData.crumbData = crumbData;
              return this.navData;
            } else {
              if (leftNavigation[i].itemData[j].itemData != null) {
                for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
                  if (leftNavigation[i].itemData[j].itemData[k]?.navPath == breadcerumbUrl) {
                    crumbData.push(leftNavigation[i].item);
                    crumbData.push(leftNavigation[i].itemData[j].item);
                    crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                    this.navData.crumbData = crumbData;
                    return this.navData;
                  } else {
                    if (leftNavigation[i].itemData[j].itemData[k].itemData != null) {
                      for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l]?.navPath == breadcerumbUrl) {
                          crumbData.push(leftNavigation[i].item);
                          crumbData.push(leftNavigation[i].itemData[j].item);
                          crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                          crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                          this.navData.crumbData = crumbData;
                          return this.navData;
                        }
                        else {
                          if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                            for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                              if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath == breadcerumbUrl) {
                                crumbData.push(leftNavigation[i].item);
                                crumbData.push(leftNavigation[i].itemData[j].item);
                                crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                                crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                                crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item);
                                this.navData.crumbData = crumbData;
                                return this.navData;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    this.navData.crumbData = null;
    this.navData.menuData = null;
    return this.navData;
  }

  getMenuData(leftnav) {   
    this.menuData = [];
    for (let i = 0; i < leftnav.length; i++) {
      this.menuData.push({ menuItem: leftnav[i].item, menuUrl: leftnav[i].itemLink, menuRollUp: leftnav[i].rollUp, childData: this.getChilds(leftnav[i]) });
    }
  }
  childData: any[] = [];
  getChildData(leftNav) {
    this.childData = [];
    if (leftNav.itemData.length > 0) {
      for (let i = 0; i < leftNav.itemData.length; i++) {
        this.childData.push({ menuItem: leftNav.itemData[i].item, menuUrl: leftNav.itemData[i].itemLink, menuRollUp: leftNav.itemData[i].rollUp });
      }
    } else { this.childData = []; }
    return this.childData;
  }

  getChilds(leftNav) {
    let childData: any = [];
    if (leftNav.itemData.length > 0) {
      for (let i = 0; i < leftNav.itemData.length; i++) {
        childData.push({ menuItem: leftNav.itemData[i].item, menuUrl: leftNav.itemData[i].itemLink, menuRollUp: leftNav.itemData[i].rollUp });
      }
    } else { childData = []; }
    return childData;
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  annotationToggle: boolean = false;
  public toggle(event: MatSlideToggleChange) {
    this.annotationToggle = event.checked;
  }

  isShowAllRequired(breadCrumbMenuData) {
    for (let i = 0; i < breadCrumbMenuData.length; i++) {
      if (breadCrumbMenuData[i].menuRollUp == "False" && breadCrumbMenuData[i].childData.length > 0) {
        return false;
      }
    }
    return true;
  }
}

